import Segment from "./Segment";

export default class Leg {
    public fromIsrs: string;
    public fromObjectName: string;
    public fromMessage: string;
    public toIsrs: string;
    public toObjectName: string;
    public toMessage: string;
    public message: string;
    public eta: Date;
    public etd: Date;
    public length: number;
    public segments: Segment[];

    public constructor(data: any) {
        if (!data) {
            return;
        }
        this.fromIsrs = data.FromIsrs;
        this.fromObjectName = data.FromObjectName;
        this.fromMessage = data.FromMessage;
        this.toIsrs = data.ToIsrs;
        this.toObjectName = data.ToObjectName;
        this.toMessage = data.ToMessage;
        this.message = data.Message;
        this.eta = new Date(data.ETA);
        this.etd = new Date(data.ETD);
        this.length = data.Length;
        this.segments = [];
        if (data.Segments && data.Segments.length) {
            data.Segments.forEach((s: any) => this.segments.push(new Segment(s)));
        }
    }
}